import { Children, ReactNode, isValidElement } from 'react';

/**
 * Recursively checks if children contain any text content
 * Returns true if text is found, false if only icons/elements
 */
export const hasTextContent = (children: ReactNode): boolean => {
  // Handle arrays of children
  const childArray = Children.toArray(children);

  for (const child of childArray) {
    // Direct string/number = text content
    if (typeof child === 'string' || typeof child === 'number') {
      // Ignore whitespace-only strings
      if (typeof child === 'string' && child.trim() === '') {
        continue;
      }
      return true;
    }

    // React element - check its children recursively
    if (isValidElement(child) && child.props.children) {
      if (hasTextContent(child.props.children)) {
        return true;
      }
    }
  }

  return false;
};
